import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import saveAs from 'file-saver'
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AppErrorHandler } from 'src/app/CommonService/app-error-handler.service';
import { DataService } from 'src/app/CommonService/data.service';
import { GlobalVariables } from 'src/app/GlobalVariables';
import { GTCRequisitionservice } from 'src/app/Shared/GTCRequisition.service';
import { CommonService } from 'src/app/Shared/common.service';
import { HTTPStatus } from 'src/app/CommonService/app-token-handler';
import moment from 'moment';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit{

  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] =
  ['GTCNumber','EntityName','EngPartnerName','EngManagerName','StatusName','CreatedBy','CreatedOn'];
  statusList : any;
  pageIndex: number = 1;
  length: number = 0;
  IsAllApproved: any;
  totalPage: number = 0;
  ReqDatefrom: any=undefined;
  ReqDateTo:  any=undefined;
  SearchRequistion!: FormGroup;
  entityNameList : any;
  fminDate!: Date;
  requestId: any;
  IsLoadingResults = false;
  toDate!: Date;
  dataSource: any =[];
   @ViewChild(MatPaginator) paginator!: MatPaginator;
   @ViewChild(MatSort) sort!: MatSort;

  constructor(private http: HttpClient,
    private fb: FormBuilder, 
    private _router: Router, 
    private status: HTTPStatus,
    private error: AppErrorHandler,
    private activatedRoute: ActivatedRoute,
    public _global: GlobalVariables,
    private _gtcService: GTCRequisitionservice,
    private _commonService: CommonService,
    private dbService:DataService)
{

  this.SearchRequistion = this.fb.group({
    GTCID:[],
    GTCNumber: [],
    FirmId:[],
    EngManagerName:[],
    EngPartnerName:[],
    FromDate:[null],
    ToDate:[null],
    RecordStatus:[],
    PageNumber: (this._global.pageIndex),
    PageSize: (this._global.RecordSize)

});

}
ngOnInit(){
  this.requestId  = this.activatedRoute.snapshot.paramMap.get('ID');
  
  if(this.requestId == 2){
    this.IsAllApproved = false;
  }
  else{
    this.IsAllApproved = true;
  }


  this._commonService.BindDropDown('FirmType').subscribe(result => {
    this.entityNameList = result;
    //this.GetAllGTCData();
  });


      this.SearchPRList();



}
SearchPRList() {
  this._global.length = 0;
    this._global.pageIndex = 0;
    this._global.totalPage = 0;

  this.GetAllGTCData();
  
}

onSubmit(){
    // MatPaginator is zero-based; GetAllGTCData converts this to the API's one-based PageNumber.
    this._global.pageIndex = 0;
    this._global.length = 0;
    this._global.totalPage = 0;
    this.GetAllGTCData();
}
Exit(){
  this._router.navigate(['/home']);
}
ResetData(){
    if (confirm('Are you sure want to reset from the form.')) {
      this.SearchRequistion.reset();
     this.SearchPRList();
    }
}
onGetDataResult(data:any){

  this._router.navigate(['home/createRequistion/edit/' + data.RequestEntityId]);
}
GetResult(){
  this.SearchRequistion.controls['PageNumber'].setValue(1);
  this.SearchRequistion.controls['PageSize'].setValue(100000);
  this.status.setHttpStatus(true);
  this.dbService.DownloadFileWithPost('TaxGTC/ExportToExcel', this.SearchRequistion.value).subscribe((x: BlobPart) => {
    console.log("value: "+x);
   
    const data = new Blob([x], { type: 'application/octet-stream' });
    saveAs(data, 'Report_GTC.xlsx');
    // this.IsLoadingResults = false;
  }, (error: any) => {
    // this.IsLoadingResults = false;
    // this.status.setHttpStatus(false);
    this.error.handleError(error);
  },
    () => { this.status.setHttpStatus(false); });


  this._global.pageIndex = 0;
  this._global.length = 0;
  this._global.totalPage = 0;
  this.GetAllGTCData();
}


orgValueChange(value :any){

}
GetAllGTCData(){
  this.IsLoadingResults = true;
  if(this.requestId ==2){
    this.SearchRequistion.controls['RecordStatus'].setValue(4);
  }
  this.SearchRequistion.controls['PageNumber'].setValue(this._global.pageIndex + 1);
  this.SearchRequistion.controls['PageSize'].setValue(this._global.RecordSize);

  const formValue = this.SearchRequistion.getRawValue();
  const requestPayload = {
    ...formValue,
    FromDate: this.formatSearchDate(formValue.FromDate),
    ToDate: this.formatSearchDate(formValue.ToDate)
  };

  // sessionStorage.setItem('ViewGTCRequisition', JSON.stringify(this.SearchRequistion.getRawValue()));

  this._gtcService.GetAllFDetailsOfGTCForm(requestPayload, false).subscribe((result:any) => {
    this.dataSource = result;
    if (this.dataSource != null && this.dataSource.length > 0) {
      this._global.length = this.dataSource[0].Totalrecordcount;
      this._global.totalPage = Math.ceil(this._global.length / this._global.RecordSize);
    } else {

      this._global.length = 0;
      this._global.pageIndex = 0;
      this._global.totalPage = 0;
      alert('No result found');
    
    }
  this.IsLoadingResults = false;

  });
}
private formatSearchDate(value: any): string | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (moment.isMoment(value)) {
    return value.isValid() ? value.format('YYYY-MM-DD') : null;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime()) ? moment(value).format('YYYY-MM-DD') : null;
  }

  const parsedDate = moment(value, moment.ISO_8601, true);
  return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : null;
}
GoToPage() {
  if (this.pageIndex <= 0) { this.pageIndex = 1; }
  else if (this.pageIndex > this.totalPage) { this.pageIndex = this.totalPage; }
  this.GetAllGTCData();
}
onPaginateChange(event: any) {
this._global.pageIndex = event.pageIndex;
this._global.RecordSize = event.pageSize;
this.GetAllGTCData();
}
}


